<mat-expansion-panel [expanded]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{dienst.getLabel()}}
    </mat-panel-title>
    <mat-panel-description>
      {{clientDienst.getZoneId() | zahZone:zones}}
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <div class="content">
      <mat-form-field>
        <mat-label>Zone</mat-label>
        <mat-select [value]="clientDienst.getZoneId()" (valueChange)="onZoneChanged($event)">
          @for (zone of dienst.getAvailableZoneIds(); track zone) {
            <mat-option [value]="zone">
              {{zone | zahZone:zones}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @for (taakType of taakTypes; track taakType; let isFirst = $first) {
        <zah-taak-type
          [expanded]="isFirst"
          [taakType]="taakType"
          [clientDienst]="clientDienst"
          [dienst]="dienstFilteredOnTaakType[taakType]">
        </zah-taak-type>
      }
      <mat-action-row>
        <button mat-icon-button
          color="primary"
          class="delete"
          (click)="onDeleteClick()">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </mat-action-row>
    </div>
  </ng-template>
</mat-expansion-panel>
